import { Component, OnInit, OnDestroy } from '@angular/core';
import { NavbarService } from '../navbar/navbar.service';
import { SpinnerService } from '../../services/spinner.service';
import { Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { featureFlag } from 'src/environments/environment';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit, OnDestroy {
  constructor(
    private navbarService: NavbarService,
    private router: Router,
    private spinner: SpinnerService,
    private store: Store,
  ) {}
  ngOnDestroy(): void {
    this.spinner.hide();
  }

  ngOnInit(): void {
    this.spinner.show();
    this.navbarService.setActiveSidebar(false);

    setTimeout(() => {
      // redirect to home if already logged in
      const role = this.store.selectSnapshot<string>((s) => {
        return s.auth.role;
      });
      if (role) {
        if (
          featureFlag.memo_enable &&
          ['general', 'admin'].includes(role.toLowerCase())
        ) {
          this.router.navigate(['/memos']);
        } else if (role.toLowerCase() === 'contract management') {
          this.router.navigate(['/contract']);
        } else {
          this.router.navigate(['/users']);
        }
        this.navbarService.setActiveSidebar(true);
      } else {
        this.router.navigate(['/login']);
      }
    }, 1500);
  }
}
